export class FunctionUtils {
    public static createFunction(func:Function, thisParam:any):Function{
        let _this = thisParam;
        let newFunc = function newFunction() {
            return func.call(this, _this);
        }
        return newFunc;
    }

    public static createFunction2(func:Function, thisParam:any):Function{
        let _this = thisParam;
        let newFunc = function newFunction( firstParam:any ) {
            return func.call(this, _this, firstParam);
        }
        return newFunc;
    }
}